// extracted by mini-css-extract-plugin
export default {"success":"SuccessIcon_success__GtnAi"};